function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});
document.addEventListener('DOMContentLoaded', () => {
    console.log("Script loaded"); // Debug statement
    // Function to update the delivery date
    function updateDeliveryDate() {
        const deliveryDateElement = document.querySelector('.deliverydate');
        if (deliveryDateElement) {
            const shippingDays = parseInt(deliveryDateElement.getAttribute('data-shippingsday'), 10);
            const today = new Date();
            const deliveryDate = new Date(today);
            deliveryDate.setDate(today.getDate() + shippingDays);
            const options = { weekday: 'long', day: 'numeric', month: 'short' };
            deliveryDateElement.textContent = deliveryDate.toLocaleDateString('en-US', options);
        }
    }
    // Function to update the countdown timer
    function updateTimer() {
        const estimatedTimeElement = document.querySelector('.estimated-time');
        if (estimatedTimeElement) {
            const hours = parseInt(estimatedTimeElement.getAttribute('data-hours'), 10);
            const minutes = parseInt(estimatedTimeElement.getAttribute('data-minutes'), 10);
            const timerElement = document.getElementById('timer');
            let endTime = new Date();
            endTime.setHours(endTime.getHours() + hours);
            endTime.setMinutes(endTime.getMinutes() + minutes);
            function updateCountdown() {
                const now = new Date();
                const timeLeft = endTime - now;
                if (timeLeft > 0) {
                    const hoursLeft = Math.floor(timeLeft / (1000 * 60 * 60));
                    const minutesLeft = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                    const secondsLeft = Math.floor((timeLeft % (1000 * 60)) / 1000);
                    timerElement.innerHTML = `<b>${hoursLeft} HOURS ${minutesLeft} MINUTES</b>`;
                } else {
                    clearInterval(timerInterval);
                    timerElement.innerHTML = "<b>TIME EXPIRED</b>";
                }
            }
            updateCountdown(); // Initial call
            const timerInterval = setInterval(updateCountdown, 1000); // Update every second
        }
    }
    // Initialize the delivery date and timer
    updateDeliveryDate();
    updateTimer();
});
/* countdown header */
document.addEventListener('DOMContentLoaded', function() {
  function startCountdown(duration) {
    var timer = duration, hours, minutes, seconds;
    setInterval(function() {
      hours = parseInt(timer / 3600, 10);
      minutes = parseInt((timer % 3600) / 60, 10);
      seconds = parseInt(timer % 60, 10);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      document.getElementById('hours').textContent = hours;
      document.getElementById('minutes').textContent = minutes;
      document.getElementById('seconds').textContent = seconds;

      if (--timer < 0) {
        timer = duration;
      }
    }, 1000);
  }

  // Start the countdown timer with 24 hours
  startCountdown(24 * 3600);
});

document.addEventListener('DOMContentLoaded', function() {
  const circles = document.querySelectorAll('.circle');
  
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const circle = entry.target;
        const percentage = circle.style.getPropertyValue('--percentage');
        circle.style.strokeDasharray = `${percentage}, 100`;
        observer.unobserve(circle);
      }
    });
  }, observerOptions);

  circles.forEach(circle => {
    observer.observe(circle);
  });
});




document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());



